import StoneAccountList from '@/components/Stone/StoneAccountList';
import { useStoneAccountDetail } from '@/core/domain/stone/stoneAccount/stoneAccount.hooks';
import { useWindowSize } from '@/hooks';
import { Form, Typography } from 'antd';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const { Title } = Typography;

interface FormValues {
  accountId: string;
  accountName: string;
  accountSocialReason: string;
  accountSecretKey: string;
  accountCnpj: string;
}

const StonePage = () => {
  const { width } = useWindowSize();

  const stoneAccountDetail = useStoneAccountDetail();

  const [form] = Form.useForm<FormValues>();

  useEffect(() => {
    if (stoneAccountDetail.data) {
      form.setFieldsValue(stoneAccountDetail.data);
    }
  }, [stoneAccountDetail.dataUpdatedAt]);

  return (
    <div className="page">
      <Helmet title="Stone" />
      <div className="page-header">
        <Title level={width < 576 ? 5 : 4}>Stone - Contas de integração</Title>
      </div>

      <StoneAccountList />
    </div>
  );
};

export default StonePage;
